export const CHECKOUT_URL = 'https://tcm-en.impultienda.ar/checkout'

export const offer = {
  price: '$27',
  totalValue: '$294',
  volumesValue: '$97',
  bonusesValue: '$197',
  spotsTotal: 100,
  spotsLeft: 7,
  microcopy: 'Instant download · One-time payment of USD $27 · Lifetime access · 7-day guarantee',
}

export const images = {
  hero: 'https://cdn.magicpatterns.com/uploads/4pktbT7c6s9zfvNmW4BbX9/TCM-EN.png',
  creator: 'https://cdn.magicpatterns.com/uploads/ipcEvWrj3nn4xYZKpcqErk/Jason_Mitchell.png',
}
